import API from "core/api/axios/base";
import UserInfoErrorHandler from "core/api/handler/UserInfoErrorHandler";
import Cookies from "universal-cookie";
export default function userInfo(callback) {
  const cookies = new Cookies();
  let accesstoken = cookies.get("accesstoken");
  let config = {
    headers: {
      "content-type": "application/json",
      "x-client-key": process.env.REACT_APP_CLIENT_KEY,
      Authorization: "Bearer " + accesstoken,
    },
    withCredentials: true
  };
  config.headers['x-credentials-key'] = process.env.REACT_APP_X_CREDENTIALS_KEY;

  return API.get(`${process.env.REACT_APP_GETUSERINFO}`,config)
    .then((response) => {
      const {data} = response;
      const finalData = data?.data;
      if(finalData?.name){
        finalData['firstName'] = finalData?.name?.split(" ")[0];
      }
      return finalData;
    })
    .catch((error) => {
      const errorHandler = UserInfoErrorHandler(error);
      const responseError = {
        ...errorHandler,
      };
      return responseError;
    });
}
